import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { smoothlyMenu } from 'src/app/shared/app.helpers';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AlteraSenhaComponent } from '../altera-senha/altera-senha.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/shared/services/storage.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { SuporteLocalService } from 'src/app/modules/chat-bot/services/suporte-local.service';
import { SuporteGeralService } from 'src/app/modules/chat-bot/services/suporte-geral.service';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';

declare var jQuery: any;

@Component({
  selector: 'app-topnavbar',
  templateUrl: 'topnavbar.template.html',
  styleUrls: ['./topnavbar.component.scss'],
})
export class TopNavbarComponent extends BaseListComponent<any> implements OnInit {

  public hasSupport: boolean = false;
  public hasSupportLocal: boolean = false;
  public hasSupportGeral: boolean = false;
  public hasPermissionSupportLocal: boolean = false;
  public hasPermissionSupportGeral: boolean = false;
  public modalRef: BsModalRef;
  public modalRefEnte: BsModalRef;
  public nomeUsuario: string;
  public orgaoUsuario: string;
  public entidades: Record<string, any>[];
  public entidade: number;
  public currentEntidade: number;
  menuView = false;
  mgsInfo: string;

  @ViewChild("modalEnte") modalEnte: TemplateRef<any>;
  

  constructor(
    private authService: AuthService,
    private bsModalService: BsModalService,
    private router: Router,
    private storage: StorageService,
    private loginService: LoginService,
    private suporteLocalService: SuporteLocalService,
    private suporteGeralService: SuporteGeralService,
    private navigation: NavigationService
  ) { 
    super();
  }

  ngOnInit() {
    this.loaded();
    this.authService.userInfo().then(async(user) => {
      this.nomeUsuario = user.data.str_nome;
      this.storage.setInfoUser(user.data)
      this.getEntidades();
      
      this.currentEntidade = await this.authService.getSession();

      this.hasPermissionSupportLocal = user.data['permission_support_local'];
      this.hasPermissionSupportGeral = user.data['permission_support_geral'];
      this.hasCompletedSupport();
      if(this.hasPermissionSupportLocal){
        this.hasOpeningLocalSupport();
      }      
      if(this.hasPermissionSupportGeral){
        this.hasOpeningGeralSupport();
      }

      let matches = this.nomeUsuario.match(/\(([^)]+)\)/);
      if (matches) {
        let usuario = this.nomeUsuario.replace(matches[0], "").trim();
        let orgao = matches[1];
        this.nomeUsuario = usuario;
        this.orgaoUsuario = orgao;
      }
    });

    EventSharedService.get('mgsInfo').subscribe((res) => {
      this.mgsInfo = res;
    })
  }

  toggleNavigation(): void {
    EventSharedService.get('menuView').emit();
   //jQuery('body').toggleClass('mini-navbar');
   //smoothlyMenu();
  }

  alterarSenha(){
    this.router.navigate(['/alterar-senha']);
  }

  alterarSenhaDialog() {
    this.modalRef = this.bsModalService.show(AlteraSenhaComponent, {
      class: 'modal-lg',
    });
  }

  vincularSoe() {
    this.authService.soewebVincularAuthentication()
      .then((redirecUrl) => {
        window.location.href = redirecUrl;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  hasCompletedSupport(){
			this.suporteLocalService.hasCompletedSupport().subscribe({
				next: (res: boolean) => {
					this.hasSupport = res;
				},
				error: (error) => {
				},
			})
  }
  hasOpeningLocalSupport(){
    this.suporteLocalService.hasOpenSupport().subscribe({
      next: (res: boolean) => {
        this.hasSupportLocal = res;
      },
      error: (error) => {
      },
    })
  }
  hasOpeningGeralSupport(){
    this.suporteGeralService.hasOpenSupport().subscribe({
      next: (res: boolean) => {
        this.hasSupportGeral = res;
      },
      error: (error) => {
      },
    })
  }

  signout() {
    this.router.navigate(['logout']);
  }

  get lebelEntidade(){
    return this.entidades?.find(e => e.id == this.currentEntidade)?.label;
  }

  setEntidade(): void{
    this.loading();
    this.authService.setSession(this.entidade);
    this.loading();
    this.loginService.setUserEntidades(this.entidade).subscribe({
      next: (value) => {
        this.navigation.replace(['/projetos', 'projeto']);
        window.location.reload();
      },
      error: (err) => {
        console.error(err);
        this.msgError('Erro ao tentar trocar de entidade')
        this.loaded();
      },
    });
  }

  getEntidades():void {
    this.loginService.getUserEntidades().subscribe({
      next: (value) => {
        this.entidades = value;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  alterarEnteFederativo(): void{
    this.modalRefEnte = this.bsModalService.show(this.modalEnte);
  }

  closeModal(): void {
    this.modalRefEnte?.hide();
    this.entidade = null;
  }
}
